module.exports = __webpack_public_path__ + "img/peace_active.2ff1c1c2.svg";